import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import QuotesList from '../../components/Quote/QuotesList';
import GlassWorkspaceShell from '../../components/Glass/GlassWorkspaceShell';

/**
 * QuotesPage Component.
 *
 * Manages and displays two tabs of quotes: unfulfilled and fulfilled.
 * Fetches supplier select list once and shares it across all tabs.
 *
 * @module QuotesPage
 */

const QuotesPage = () => {
  const [activeTab, setActiveTab] = useState('unfulfilled');

  // Don't fetch supplier select list automatically - only fetch when quote creation modal is opened
  // The QuoteModal component will handle the fetching when it opens

  return (
    <GlassWorkspaceShell theme="yellow" wide>
      <div className="glass-toolbar">
        <Nav fill variant="tabs" defaultActiveKey="unfulfilled">
          <Nav.Item>
            <Nav.Link
              eventKey="unfulfilled"
              onClick={() => setActiveTab('unfulfilled')}
            >
              Unfulfilled Quotes
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="fulfilled"
              onClick={() => setActiveTab('fulfilled')}
            >
              Fulfilled Quotes
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>

      <div style={{ display: activeTab === 'unfulfilled' ? 'block' : 'none' }}>
        <QuotesList activeTab="unfulfilled" supplierSelectList={[]} />
      </div>
      <div style={{ display: activeTab === 'fulfilled' ? 'block' : 'none' }}>
        <QuotesList activeTab="fulfilled" supplierSelectList={[]} />
      </div>
    </GlassWorkspaceShell>
  );
};

export default QuotesPage;
